"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowSpaceWrapper = exports.TimelineCaption = exports.Timeline = exports.TimelineSubtitleExtra = exports.TimelineSubtitle = exports.TimelineWrapper = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesGridStyles__Wrapper",
  componentId: "sc-18m842p-0"
})(["width:100%;background:#3d4a69;position:relative;"]);

exports.Wrapper = Wrapper;

var TimelineWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesGridStyles__TimelineWrapper",
  componentId: "sc-18m842p-1"
})(["width:99%;display:flex;flex-direction:row;"]);

exports.TimelineWrapper = TimelineWrapper;

var TimelineSubtitle = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesGridStyles__TimelineSubtitle",
  componentId: "sc-18m842p-2"
})(["line-height:50px;color:#fff;font-weight:bold;margin-left:15px;border-top:5px solid #242e42;margin-top:10px;font-size:19px;"]);

exports.TimelineSubtitle = TimelineSubtitle;

var TimelineSubtitleExtra = _styledComponents["default"].span.withConfig({
  displayName: "TrafficSpacesGridStyles__TimelineSubtitleExtra",
  componentId: "sc-18m842p-3"
})(["font-size:13px;opacity:.6;"]);

exports.TimelineSubtitleExtra = TimelineSubtitleExtra;

var Timeline = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesGridStyles__Timeline",
  componentId: "sc-18m842p-4"
})(["min-width:2000px;display:flex;flex-direction:row;padding:0.4rem 0 0.4rem 0;position:relative;"]);

exports.Timeline = Timeline;

var TimelineCaption = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesGridStyles__TimelineCaption",
  componentId: "sc-18m842p-5"
})(["width:", ";color:", ";display:flex;flex-direction:row;margin-right:0.2rem;overflow:hidden;"], function (_ref) {
  var width = _ref.width;
  return width || '100%';
}, function (_ref2) {
  var isCurrentTime = _ref2.isCurrentTime;
  return isCurrentTime ? 'white' : '#778197';
});

exports.TimelineCaption = TimelineCaption;

var RowSpaceWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesGridStyles__RowSpaceWrapper",
  componentId: "sc-18m842p-6"
})(["heigh:auto;background:#3d4a69;max-height:530px;overflow:auto;position:relative;padding-right:10px;box-sizing:border-box;"]);

exports.RowSpaceWrapper = RowSpaceWrapper;